var heading_default = {
  "fontElementMap": "QDYSw",
  "elementSpacing": "KrSTC",
  "headerOne": "BJsfq KrSTC",
  "headerTwo": "dB7sS KrSTC",
  "headerThree": "fMFA9 KrSTC",
  "headerFour": "_4Ieg3 KrSTC",
  "headerFive": "SnYrw KrSTC",
  "headerSix": "_1ORc0 KrSTC",
  "child": "_0aAL9"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
